/**
 * @file CommonTheme.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { createTheme } from "@mui/material";

export const createCustomTheme = (fontweight: number, fontsize: number, textTransform ?: boolean)=> createTheme (
    ! textTransform ? { 
                        typography: {
                                    fontFamily: ["Roboto"].join(","), allVariants: {
                                        fontWeight: fontweight
                                    },
                                    fontSize: fontsize
                                }
                    }
                  : { 
                    typography: {
                                fontFamily: ["Roboto"].join(","), allVariants: {
                                    fontWeight: fontweight
                                },
                                button: {
                                    textTransform: 'none'
                                  },
                                fontSize: fontsize
                        }
                    }
);

export const createBoldTheme = (fontWeight: number, fontSize: number)=> createTheme ({ 
  typography: {
    fontFamily: ["Roboto"].join("bold,"), allVariants: {
        fontWeight: fontWeight
    },
    button: {
        textTransform: 'none'
      },
    fontSize: fontSize}
});

export const noTextTransform = createCustomTheme(500, 14, true);
export const roboto500Text12 = createCustomTheme(500, 12);
export const roboto500Text16 = createCustomTheme(500, 16);
export const roboto900Text12 = createCustomTheme(900, 12);
export const roboto900Text14 = createCustomTheme(900, 14);
export const roboto700Text16Bold = createBoldTheme(700, 16);
export const roboto700= ()=> createTheme (
  { 
                typography: {
                            fontFamily: ["Roboto"].join(","), allVariants: {
                                fontWeight: 700
                            }
                        }
      }
);


export const createStyledTab = ()=> createTheme (
              { 
                            typography: {
                                        fontFamily: ["Roboto"].join(","), allVariants: {
                                            fontWeight: 500
                                        }
                                    }
                  }
);